import * as React from "react";
import { forwardRef } from "react";
const SvgAccountsPayable = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 18, height: 18, viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: 2, strokeLinecap: "round", strokeLinejoin: "round", className: "lucide lucide-square-arrow-down", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("rect", { width: 18, height: 18, x: 3, y: 3, rx: 2 }), /* @__PURE__ */ React.createElement("path", { d: "M12 8v8" }), /* @__PURE__ */ React.createElement("path", { d: "m8 12 4 4 4-4" }));
const ForwardRef = forwardRef(SvgAccountsPayable);
export { ForwardRef as ReactComponent };
